import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link } from 'react-router-dom';

import AddCircleIcon from '@/assets/icons/add-circle.svg?react';
import InfoIcon from '@/assets/icons/info-icon.svg?react';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly label: string;
  readonly path: string;
  readonly help?: string;
  readonly icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const AddObjectButton: React.FC<Props> = (props: Props): React.ReactElement => {
  const { label, path, help, icon: Icon = AddCircleIcon } = props;
  const tr = useTranslator();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box
        component={Link}
        color="text.primary"
        to={path}
        display="flex"
        alignItems="center"
        gap={1}>
        <Icon fill="currentColor" />
        <Typography variant="h7" color="text.primary">
          {tr(label)}
        </Typography>
      </Box>
      {help ? (
        <Tooltip title={help}>
          <IconButton size="small" disableRipple={true}>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
    </Box>
  );
};
